<template>
  <div>
    <div id="login-area" v-if="isLoggedIn === 'no'">

      <login-area :isLogged="isLoggedIn" @changeState="changeLoggedState"></login-area>
    </div>
    <div id="panel-area" v-if="isLoggedIn === 'yes'" v-bind:class="{'nav-open': $sidebar.showSidebar}">
      <notifications></notifications>
      <router-view></router-view>
    </div>
    <div class="loader loader-hide justify-content-center align-items-center" id="loader">
      <div class="content text-center">
        <h1 class="text-white"><i class="fas fa-circle-notch fa-spin fa-4x"></i></h1>
        <h3 class="text-white">Lütfen Bekleyiniz...</h3>
      </div>
    </div>
  </div>
</template>

<script>
  import LoginArea from './components/Dashboard/Views/Login.vue'
  export default {
    data: function(){
      return {
        isLoggedIn: 'unknown'
      }
    },
    components: {
      LoginArea
    },
    methods:{
      changeLoggedState: function(event){
        this.isLoggedIn =  event
      },
      checkLoggedStatus: function(){
        this.$http.get('/api/users/is-logged-in', this.credentials).then(
          response => {
            this.isLoggedIn = 'yes'
            this.$cookies.set("panelbuzpatenicompanelsession",response.body.cookie, -1);
            // if user details was not found inside local storage log out and ask to login
            if(!localStorage.getItem("CurrentLoggedUserDetails")){
              this.$http.get('/api/users/logout', this.credentials).then(
                response => {
                  localStorage.removeItem('CurrentLoggedUserDetails');
                  this.$router.push('/main')
                  location.reload()
                },
                e => {
                  this.$router.push('/main')
                  location.reload()
                })
            }
          },
          e => {
            this.isLoggedIn = 'no'
          })
      }
    },
    mounted: function () {
      this.checkLoggedStatus()
    }
  }
</script>
<style lang="scss">
.vue-notifyjs.notifications{
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;

  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);

  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
.loader {
  width: 100%;
  height: 100vh;
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
}
.loader-hide {
  display: none;
}
.loader-show {
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/App.vue